/** Wording for the business-validation wizard — written for an investor or acquirer, not a founder. */
export const businessValidationCopy = {
  title: 'Validate a business',
  subtitle:
    'Point Vibelin at the company. It reads the public sources, writes a company brief and walks you through the due-diligence stages, one generated document at a time.',
  sources: {
    heading: 'Where can we read about the company?',
    helper:
      'The website is required. Add the LinkedIn page, a public GitHub repository and the documentation portal when they exist; each one gives the brief more to work with.',
  },
  otherUrls: {
    heading: 'Any other public pages?',
    helper: 'A pricing page, press coverage, a Crunchbase profile, an app-store listing, a review page. One address at a time.',
    label: 'Page address',
    add: 'Add',
    invalid: 'Enter a full address such as https://example.com/pricing',
  },
  focus: {
    heading: 'What should the validation focus on?',
    helper:
      'Optional. Your thesis, the deal context (round, ticket size, acquisition), the questions you want answered first, and anything you already know about the company. Markdown works.',
    label: 'Focus points and notes',
    placeholder: [
      '## Thesis',
      'Vertical SaaS for independent clinics with a real switching-cost moat; Series A, we would lead with $4M.',
      '',
      '## Validate first',
      '- Is the revenue really recurring, and how concentrated is it?',
      '- How defensible is the position against the two larger platforms?',
      '',
      '## What we already know',
      'Founder-led sales so far; ~40 paying clinics according to the deck.',
    ].join('\n'),
  },
  start: 'Start validation',
  startHint:
    'Creates the project, named from the website, reads the sources into a company brief and generates the first stage, Company Snapshot. You follow the progress on the next screen.',
} as const;
